// NOTE: `useState` is unused while the slider pagination is commented out below.
// Restore it together with the pagination when more slides are added.
import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { useLiveStatus } from "../../context/LiveStatusContext";

const slides = [
  {
    arabic: `إِنَّ ٱلَّذِينَ يُبَايِعُونَكَ إِنَّمَا يُبَايِعُونَ ٱللَّهَ يَدُ ٱللَّهِ فَوْقَ أَيْدِيهِمْ ۚ فَمَن نَّكَثَ فَإِنَّمَا يَنكُثُ عَلَىٰ نَفْسِهِۦ ۖ وَمَنْ أَوْفَىٰ بِمَا عَـٰهَدَ عَلَيْهُ ٱللَّهَ فَسَيُؤْتِيهِ أَجْرًا عَظِيمًۭا ١٠
`,
    english:
      "Surely those who pledge allegiance to you ˹O Prophet˺ are actually pledging allegiance to Allah. Allah’s Hand is over theirs. Whoever breaks their pledge, it will only be to their own loss. And whoever fulfils their pledge to Allah, He will grant them a great reward.",
    reference: "— Al Fatah 48:10",
  },
  {
    arabic: `إِنَّ ٱلَّذِينَ يُبَايِعُونَكَ إِنَّمَا يُبَايِعُونَ ٱللَّهَ يَدُ ٱللَّهِ فَوْقَ أَيْدِيهِمْ ۚ فَمَن نَّكَثَ فَإِنَّمَا يَنكُثُ عَلَىٰ نَفْسِهِۦ ۖ وَمَنْ أَوْفَىٰ بِمَا عَـٰهَدَ عَلَيْهُ ٱللَّهَ فَسَيُؤْتِيهِ أَجْرًا عَظِيمًۭا ١٠
`,
    english:
      "Surely those who pledge allegiance to you ˹O Prophet˺ are actually pledging allegiance to Allah. Allah’s Hand is over theirs. Whoever breaks their pledge, it will only be to their own loss. And whoever fulfils their pledge to Allah, He will grant them a great reward.",
    reference: "— Al Fatah 48:10",
  },
  {
    arabic: `إِنَّ ٱلَّذِينَ يُبَايِعُونَكَ إِنَّمَا يُبَايِعُونَ ٱللَّهَ يَدُ ٱللَّهِ فَوْقَ أَيْدِيهِمْ ۚ فَمَن نَّكَثَ فَإِنَّمَا يَنكُثُ عَلَىٰ نَفْسِهِۦ ۖ وَمَنْ أَوْفَىٰ بِمَا عَـٰهَدَ عَلَيْهُ ٱللَّهَ فَسَيُؤْتِيهِ أَجْرًا عَظِيمًۭا ١٠
`,
    english:
      "Surely those who pledge allegiance to you ˹O Prophet˺ are actually pledging allegiance to Allah. Allah’s Hand is over theirs. Whoever breaks their pledge, it will only be to their own loss. And whoever fulfils their pledge to Allah, He will grant them a great reward.",
    reference: "— Al Fatah 48:10",
  },
];

export default function HeroSection() {
  const { isLive } = useLiveStatus();
  // const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  return (
    <section className="relative h-full w-full text-white overflow-hidden">
      <Swiper
        // modules={[Autoplay]}
        // autoplay={{ delay: 5000, disableOnInteraction: false }}
        onSwiper={(swiper) => (swiperRef.current = swiper)} // store instance
        // onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        className="h-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="eachSlide flex flex-col md:flex-row h-full paddingAdjust justify-center">
              {/* English side */}
              <div className="englishCaption md:mb-2 w-full md:w-1/2 flex md:flex-col items-start justify-end mt-2 md:mt-0">
                <p className="text-base md:text-[22px] lg:text-[20px] text-gray-200 leading-6">
                  {slide.english}
                  <span className="mt-4 block text-[20px] text-white font-normal">
                    {slide.reference}
                  </span>
                </p>
                {/* Desktop slider pagination — hidden while the hero is static.
                    Restore when more slides are added.
                <div className="pagination mt-5 mb-5">
                  <div className="hidden md:flex items-center gap-2 text-sm text-gray-400">
                    {slides.map((_, i) => (
                      <span
                        key={i}
                        className={`h-[8px] w-12 rounded-sm transition-all duration-300 cursor-pointer ${
                          i === activeIndex ? "bg-white" : "bg-gray-500"
                        }`}
                        onClick={() => {
                          if (swiperRef.current)
                            swiperRef.current.slideTo(i, 500);
                        }}
                      />
                    ))}
                    <span className="ml-2 text-sm paginationText">
                      {activeIndex + 1} / {slides.length}
                    </span>
                  </div>
                </div>
                */}
              </div>

              {/* Arabic side */}
              <div className="arabicCaption w-full md:w-1/2 flex items-center justify-end">
                <p
                  className="text-[24px] leading-[32px] md:text-[36px] lg:text-[44px] font-arabic font-normal text-right md:leading-[1.6] mb-1 pb-0"
                  dir="rtl"
                >
                  {slide.arabic}
                </p>
              </div>

              {/* Mobile slider pagination — hidden while the hero is static.
                  Restore when more slides are added.
              <div className="position-absolute bottom-0 left-10 pagination mt-0 mb-4 md:mt-5 md:mb-5 flex gap-2 text-sm text-gray-400 order-3">
                <div className="md:hidden flex items-center gap-1">
                  {slides.map((_, i) => (
                    <span
                      key={i}
                      className={`h-[6px] w-6 rounded-sm transition-all duration-300 ${
                        i === activeIndex ? "bg-white" : "bg-gray-500"
                      }`}
                      onClick={() => {
                        if (swiperRef.current)
                          swiperRef.current.slideTo(i, 500);
                      }}
                    />
                  ))}
                  <span className="ml-2 text-sm paginationText">
                    {activeIndex + 1} / {slides.length}
                  </span>
                </div>
              </div>
              */}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="md:mb-0 absolute bottom-[30px] md:bottom-0 right-6 z-10 flex items-center justify-end px:4 md:px-16">
        <div className="flex items-end md:items-center flex-col md:flex-row gap-2 ml-6">
          {isLive && (
            <div className="animate-pulse">
              <img
                src="/images/liveImage.png"
                alt="Logo"
                width={100}
                height={100}
                className="w-13 h-13 sm:w-24 sm:h-24 md:h-13 md:w-13"
              />
            </div>
          )}
          {isLive && (
            <div className="text-[14px] md:text-[20px]">
              <span className=" font-medium">Dr. Naushad Shaikh</span>
              <br />
              <span className="text-[14px] md:text-[20px] text-gray-200 font-semibold">
                is Live
              </span>
            </div>
          )}
        </div>
        {isLive && (
          <img
            src={"/images/muftiSahabImage.png"}
            alt="User"
            width={100}
            height={100}
            className="h-40 w-52 hidden lg:block"
          />
        )}
      </div>
    </section>
  );
}
